<template>
<div class="row" id="searchFilterBar-row">

  <div class="col" id="searchFilterBar-col">
    <div class="form-group" id="searchFilterBar-formGroup">
      <input type="text"
             class="form-control"
             name="search-by-identifier"
             id="search-by-identifier"
             :placeholder="'SEARCH_BY_NAME_OR_UNIQUE_ID' | translate"
             v-model="filters.identifier"
             v-on:keyup="updateFilters">
    </div>
  </div>

  <div class="col flex-ellipsis-fix" id="searchFilterBar-batchNameDropdown">
    <div class="form-group custom-multiselect" :class="{ 'opened': batchMultiselectShown }" id="searchFilterBar-batchMultiselect">
      <span v-if="filters.batch.length" class="deselect-all text-warning"
            v-on:click="clearFilter('batch')"><i class="fa fa-times" aria-hidden="true"></i></span>
      <div class="custom-select text-truncate" id="search-batch"
            @click.stop="batchMultiselectShown = !batchMultiselectShown"
            :title="filters.batch.length ? filters.batch.join(', ') : ''">
        {{ filters.batch.length ? filters.batch.join(', ') : 'ALL_BATCHES' | translate }}
      </div>
      <div class="form-control" v-if="batchMultiselectShown"
            v-click-outside="hideBatchMultiselect" id="searchFilterBar-dropDownList">
        <div class="custom-control custom-checkbox" v-for="batchId in availableBatchIds" :key="batchId" :id="'custom-checkbox'+batchId">
          <input class="custom-control-input" type="checkbox" :id="'checkbox_'+batchId"
                  :value="batchId" v-model="filters.batch" v-on:change="updateFilters">
          <label class="custom-control-label d-block"
                  :for="'checkbox_'+batchId" :title="batchId" :id="'checkbox-label-'+batchId">
            <span class="d-block text-truncate">{{ batchId }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-1 ml-auto" id="searchFilterBar-clearButtonDiv">
    <button class="btn btn-primary btn-block" v-on:click="clear" id="btn-filter-clear">Wis</button>
  </div>

</div>
</template>

<script>
import GeneralConfigService from '../../service/GeneralConfigService';
import { clickOutsideDirective } from '../../directives/ClickOutside';
import _ from 'lodash';

export default {
  props: ['identifier', 'batch', 'loaded'],
  data: function() {
    return {
      filters: {
        identifier: '',
        batch: []
      },
      availableBatchIds: [],
      batchMultiselectShown: false
    }
  },
  directives: {
    'click-outside': clickOutsideDirective
  },
  async beforeMount() {
    await this.init();
  },
  computed: {
    debouncedEmitUpdatedFilters: function() {
      return _.debounce(this.emitUpdatedFilters, 1000);
    }
  },
  methods: {
    updateFilters: function(event) {
      this.debouncedEmitUpdatedFilters();
      if (event.key === 'Enter') this.debouncedEmitUpdatedFilters.flush();
    },
    emitUpdatedFilters: function() {
      this.$emit('input', this.filters);
      this.$emit('filter', this.filters);
    },
    async init() {
      this.availableBatchIds = await GeneralConfigService.getCustomerBatchIds();
      this.filters.identifier = this.identifier || '';
      this.filters.batch = this.batch ? this.batch.split(',') : [];
    },
    clearFilter: function(filter) {
      this.filters[filter] = [];
      this.debouncedEmitUpdatedFilters();
      this.debouncedEmitUpdatedFilters.flush();
    },
    clear: function() {
      this.filters.identifier = '';
      this.filters.batch = [];
      this.debouncedEmitUpdatedFilters();
      this.debouncedEmitUpdatedFilters.flush();
    },
    hideBatchMultiselect: function() {
      this.batchMultiselectShown = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.row > div {
  padding: 0 .75rem;
}
.col:nth-child(1) {
  flex: 0 0 49.5%;
  max-width: 49.5%;
}
.col:nth-child(2) {
  flex: 0 0 24.5%;
  max-width: 24.5%;
}
.flex-ellipsis-fix {
  min-width: 0;
}
.form-group {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/customers/SearchFilterBar.vue